export function normalizeStatus(s) {
  return String(s || "").toLowerCase().trim();
}

export function getStatusLabel(status) {
  const s = normalizeStatus(status);

  switch (s) {
    case "paid":
      return "Оплачено";
    case "draft":
      return "Чернетка";
    case "cancelled":
    case "canceled":
      return "Скасовано";
    case "pending":
      return "В очікуванні";
    default:
      return status || "Замовлення";
  }
}